<template>
  <div class="messageContentBox" @mouseover="(e) => mouseoverMsg(e, msg)" @mouseleave="(e) => mouseleaveMsg(e, msg)">
    <!--  消息头部显示区块, 如果是自己的消息  -->
    <div v-if="msg.from == currentUser.id || msg.from == IMLoginInfo.ip" class="messageOperatIconBox">
      <!-- 撤回 -->
      <!-- 新增了个需求, 现在音视频有关的消息禁止撤回 -->
      <div
        v-if="retractMsgId && msg.id === retractMsgId && (!msg.ext || !msg.ext.banRecall || msg.ext.banRecall !== '1')"
        class="retractBox"
        :title="$t('撤回')"
        @click="recallMessage(msg)"
      >
        <a-icon type="rollback" style="font-size: 12px" />
      </div>
      <!-- 撤回 -->
      <!-- 已读状态 -->
      <div v-show="msg.status === 'read'" class="readStatusBox">
        {{ $t('已读') }}
      </div>
      <!-- 已读状态结束 -->
      <!-- loading状态 -->

      <div v-if="msg.status === 'loading'" class="sk-chase">
        <div class="sk-chase-dot" />
        <div class="sk-chase-dot" />
        <div class="sk-chase-dot" />
        <div class="sk-chase-dot" />
        <div class="sk-chase-dot" />
        <div class="sk-chase-dot" />
      </div>

      <!-- 发送失败 -->
      <template v-if="msg.status === 'error'">
        <svg
          style="width: 18px"
          t="1621321644222"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="2352"
          width="200"
          height="200"
        >
          <path
            d="M512 85.333333c-235.52 0-426.666667 190.933333-426.666667 426.666667s191.146667 426.666667 426.666667 426.666667 426.666667-190.933333 426.666667-426.666667-191.146667-426.666667-426.666667-426.666667zM554.666667 725.333333l-85.333333 0 0-85.333333 85.333333 0 0 85.333333zM554.666667 554.666667l-85.333333 0 0-256 85.333333 0 0 256z"
            p-id="2353"
            fill="#FF3B30"
          />
        </svg>
        <!-- <a
              style="color:#2878FF;margin-left: 4px;"
              @click="reSend(msg)"
              >重发</a
            > -->
      </template>

      <!-- loading状态结束 -->
      <!-- 发送失败 -->
      <!-- 发送失败结束 -->
    </div>
    <!--  消息头部显示区块  -->

    <template v-if="!msg.contentsType || msg.contentsType === 'TEXT'">
      <div v-if="msg.ext && msg.ext.yunhzhContentType !== 'purchase'" class="text">
        <!-- 如果是有采购链接或者招商链接 -->
        <p
          v-if="msg.ext && (msg.ext.moduleId === '23' || msg.ext.moduleId === '24')"
          v-html="setProcurementLink(msg)"
        />
        <p
          v-else
          @contextmenu.prevent="
            (e) => {
              mouseClick(e, msg)
            }
          "
          v-html="
            getTextHtml(
              msg,
              !!(msg.from == currentUser.id || msg.from == IMLoginInfo.ip || msg.from == IMLoginInfo.nickname),
            )
          "
        />
      </div>
    </template>
    <img
      v-else-if="msg.contentsType === 'IMAGE'"
      :src="msg.url"
      style="max-width: 180px; border-radius: 8px"
      @click="
        $photoswipe.open([
          {
            src: msg.url,
            w: 1000,
            h: 500,
          },
        ])
      "
    />

    <!-- 音频格式 -->
    <VoiceBar
      v-else-if="msg.contentsType === 'VOICE'"
      :src="msg.url"
      :is-me="msg.from == currentUser.id || msg.from == IMLoginInfo.ip"
    />
    <!-- 文件消息 -->
    <div v-if="msg.contentsType === 'FILE'" class="file" @click="downloadWithBlob(msg.url, msg.filename)">
      <div class="fileInfoBox">
        <div class="fileNameBox" :title="msg.filename || '未知文件'">
          {{ msg.filename || '未知文件' }}
        </div>
        <span class="fileSize">{{ $options.filters.getfilesize(msg.file_length) }}</span>
      </div>
      <div class="fileImgBox">
        <a-icon :type="$options.filters.getIconToFileName(msg.filename)" style="font-size: 40px; color: #b8b8b8" />
      </div>
    </div>
    <!-- 文件消息 -->

    <!-- 视频消息 -->
    <video v-else-if="msg.contentsType === 'VIDEO'" :src="msg.url" controls width="230px" />
    <!-- 视频消息 -->

    <a
      v-else-if="msg.contentsType === 'LOCATION'"
      target="_blank"
      :href="`https://uri.amap.com/marker?position=${msg.lng},${msg.lat}&name=${msg.addr}&src=hw&coordinate=gaode&callnative=0`"
    >
      <img
        style="width: 300px; height: 150px"
        :src="`https://restapi.amap.com/v3/staticmap?location=${msg.lng},${msg.lat}&zoom=17&scale=2&size=300*150&markers=mid,,A:${msg.lng},${msg.lat}&key=243d122fb21dea62fc67581e7c852fec`"
      />
    </a>

    <!-- 采购邀请卡片 -->
    <div
      v-else-if="msg.ext && msg.ext.yunhzhContentType === 'purchase'"
      class="purchase-card"
      @click="viewPurchaseDetail(msg.ext.yunhzhContentProduct)"
    >
      <!-- {{ msg.ext.yunhzhContentProduct }} -->

      <div class="card-top">
        <div class="title" :title="msg.ext.yunhzhContentProduct.name">{{ msg.ext.yunhzhContentProduct.name }}</div>
        <div class="price">{{ formatPurchasePrice(msg.ext.yunhzhContentProduct) }}</div>
      </div>
      <div class="card-mid">
        <span class="status-tag">{{ getPurchaseStatusText(msg.ext.yunhzhContentProduct.status) }}</span>
      </div>
      <div class="card-bottom">
        <span class="date">{{ msg.ext.yunhzhContentProduct.createTime }}发布</span>
        <span class="link">{{ $t('查看详情') }} ></span>
      </div>
    </div>

    <OncontextMenuVue />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import VoiceBar from './VoiceBar'
import { formatTxt } from '@/utils/util'

import { downloadWithBlob, getfilesize, getIconToFileName } from '@/utils/files'
import OncontextMenuVue from '~/components/chat/components/msgItem/OncontextMenu.vue'

export default {
  name: 'MsgContBox',
  components: {
    VoiceBar,
    OncontextMenuVue,
  },
  filters: {
    getfilesize,
    getIconToFileName,
    momentTime(value) {
      if (!value) {
        return ''
      }
      return moment.unix(value / 1000).format('YYYY/MM/DD HH:mm:ss')
    },
  },
  props: {
    msg: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // 鼠标hover中的消息数据
      hoverMsgData: undefined,
    }
  },

  computed: {
    ...mapGetters({
      // 自己如果是游客的信息
      IMLoginInfo: 'chat/IMLoginInfo',
      // 当前登录的用户信息
      currentUser: 'chat/currentUser',
    }),
    // 可撤回的当前hover中的消息id
    retractMsgId() {
      console.log('可撤回的当前hover中的消息id', this.hoverMsgData)
      if (this.hoverMsgData) {
        // return this.hoverMsgData.id
        if ((new Date().getTime() - Number(this.hoverMsgData.time)) / 1000 / 60 <= 2) {
          return this.hoverMsgData.id
        }
      }
      return undefined
    },
  },
  destroyed() {
    this.$photoswipe.close()
  },
  methods: {
    formatTxt,
    downloadWithBlob,
    // 鼠标进入消息
    mouseoverMsg(e, msgData) {
      console.log('鼠标进入消息', msgData)
      this.hoverMsgData = msgData
    },
    // 鼠标离开消息
    mouseleaveMsg(e, msgData) {
      console.log('鼠标离开消息')
      this.hoverMsgData = undefined
    },
    /**
     * @description: 配置采购链接, 替换文本为url
     * @param {*}
     * @return {*}
     */
    setProcurementLink(msg) {
      const isSelf =
        msg.from === this.currentUser.id || msg.from === this.IMLoginInfo.ip || msg.from === this.IMLoginInfo.nickname
      let val = ''
      if (msg.ext.moduleId === '23') {
        val = msg.data.replace(
          /\u91C7\u8D2D\u94FE\u63A5/g,
          `<a target='_blank' style='text-decoration: underline;${
            isSelf ? 'color:#FFE966' : 'color:#3B91F3'
          }' href='/cloudProcurement/${msg.ext.bizCode}'>${this.$t('采购链接')}</a>`,
        )
      } else if (msg.ext.moduleId === '24') {
        val = msg.data.replace(
          /\u62DB\u5546\u94FE\u63A5/g,
          `<a target='_blank' style='text-decoration: underline;${
            isSelf ? 'color:#FFE966' : 'color:#3B91F3'
          }' href='/merchants/${msg.ext.bizCode}'>${this.$t('招商链接')}</a>`,
        )
      }

      console.log('setProcurementLink', msg, val)
      return val
    },
    /**
     * @description: 配置表情和链接
     * @param {*} msg
     * @param {*} toMe
     * @return {*}
     */
    getTextHtml(msg, toMe) {
      const linkColor = toMe ? '#fff' : 'rgba(0,0,0,0.65)'
      return formatTxt(msg.data || msg.msg, linkColor)
    },

    // 消息撤回
    recallMessage(msgData) {
      console.log('撤回消息')
      console.log(msgData)
      const that = this
      const oldMsgData = JSON.parse(JSON.stringify(msgData))

      // 创建新对象用于更新，避免直接修改 Vuex store 状态
      const updatedMsgData = {
        ...oldMsgData,
        status: 'recall',
        msg: '消息已撤回',
      }
      that.$store.dispatch('chat/updateMessageFormList', updatedMsgData)
      this.$forceUpdate()

      const option = {
        mid: msgData.id,
        to: msgData.to,
        type: 'chat',
        success() {
          that.$message.success('消息撤回成功')
        },
        fail(e) {
          // 撤回失败时恢复原始状态
          that.$store.dispatch('chat/updateMessageFormList', oldMsgData)

          that.$message.error('消息撤回失败')
          console.log(e)
        },
      }
      this.$WebIM.conn.recallMessage(option)
    },
    // 重发消息
    reSend(msg) {
      console.log('重发消息', msg)
      this.$emit('handleSendBtn', msg)
    },
    mouseClick(e, msg) {
      console.log('点击了', e, msg, this.$store.state.locale)

      // 鼠标点的坐标
      const oX = e.clientX
      const oY = e.clientY
      // 右键菜单出现后的位置
      this.$store.commit('chat/updateRightMenuStatus', {
        status: 'block',
        left: `${oX}px`,
        top: `${oY}px`,
        // 原始数据
        originalInfo: msg,
        // 是否允许撤回
        retractMsgId: this.retractMsgId,

        msgInfo: {
          text: this.getTextHtml(
            msg,
            !!(
              msg.from === this.currentUser.id ||
              msg.from === this.IMLoginInfo.ip ||
              msg.from === this.IMLoginInfo.nickname
            ),
          ),
          to: this.$store.state.locale,
        },
      })
    },

    // 采购卡片相关方法
    formatPurchasePrice(item) {
      if (item.amount == '面议' || item.budget == '面议') {
        return '面议'
      }
      if (item.amount !== undefined && item.amount !== null) {
        if (Number(item.amount) === 0) return '面议'
        return (item.priceFlag || '¥') + Number(item.amount).toFixed(2)
      }
      if (item.budget !== undefined && item.budget !== null) {
        if (Number(item.budget) === 0) return '面议'
        return `¥${Number(item.budget).toFixed(2)}`
      }
      return '面议'
    },
    getPurchaseStatusText(status) {
      const statusMap = {
        // 1: this.$t('待匹配'),
        // 2: this.$t('报价中'),
        // 3: this.$t('报价中'),
        1: this.$t('采购中'),
        2: this.$t('采购中'),
        3: this.$t('采购中'),
        4: this.$t('已采购'),
        5: this.$t('自主下架'),
        6: this.$t('平台下架'),
      }
      return statusMap[status] || this.$t('未知状态')
    },
    viewPurchaseDetail(item) {
      // 跳转到采购详情页
      // window.open(`/account/cloudProcurement/${item.purchaseCode}`, '_blank')
      window.open(`/account/procurement/cloud/opportunitiesDetail?purchaseCode=${item.purchaseCode}`, '_blank')
    },
  },
}
</script>
<style scoped lang="scss">
.messageContentBox {
  display: flex;
  align-items: center;

  .messageOperatIconBox {
    position: relative;
    display: flex;
    align-items: center;
    order: 4;
    min-width: 20px;
    height: 20px;
    //background-color: black;
    margin-left: 10px;
  }

  //已读状态
  .readStatusBox {
    display: flex;
    align-items: center;
    font-size: 12px;
    margin-left: 6px;
  }

  .retractBox {
    height: 100%;
    width: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    transition: all 0.3s;
    background-color: #ececec;
    cursor: pointer;
  }
}

// 采购卡片样式
.purchase-card {
  width: 280px;
  background: #fff;
  border-radius: 8px;
  padding: 12px;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

  .card-top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 8px;

    .title {
      flex: 1;
      font-size: 14px;
      color: #333;
      font-weight: 500;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-right: 8px;
    }

    .price {
      font-size: 14px;
      color: #ff6600;
      font-weight: 500;
      white-space: nowrap;
    }
  }

  .card-mid {
    margin-bottom: 8px;

    .status-tag {
      display: inline-block;
      font-size: 12px;
      padding: 2px 6px;
      border-radius: 2px;
      color: #666;
      background-color: #f5f5f5;
      border: 1px solid #d9d9d9;
    }
  }

  .card-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    color: #999;

    .link {
      color: #0076ff;
    }
  }
}

//后期可以考虑放到全局
.sk-chase {
  width: 18px;
  height: 18px;
  position: relative;
  animation: sk-chase 2.5s infinite linear both;
}

.sk-chase-dot {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  animation: sk-chase-dot 2s infinite ease-in-out both;
}

.sk-chase-dot:before {
  content: '';
  display: block;
  width: 25%;
  height: 25%;
  background-color: #c1c1c1;
  border-radius: 100%;
  animation: sk-chase-dot-before 2s infinite ease-in-out both;
}

.sk-chase-dot:nth-child(1) {
  animation-delay: -1.1s;
}

.sk-chase-dot:nth-child(2) {
  animation-delay: -1s;
}

.sk-chase-dot:nth-child(3) {
  animation-delay: -0.9s;
}

.sk-chase-dot:nth-child(4) {
  animation-delay: -0.8s;
}

.sk-chase-dot:nth-child(5) {
  animation-delay: -0.7s;
}

.sk-chase-dot:nth-child(6) {
  animation-delay: -0.6s;
}

.sk-chase-dot:nth-child(1):before {
  animation-delay: -1.1s;
}

.sk-chase-dot:nth-child(2):before {
  animation-delay: -1s;
}

.sk-chase-dot:nth-child(3):before {
  animation-delay: -0.9s;
}

.sk-chase-dot:nth-child(4):before {
  animation-delay: -0.8s;
}

.sk-chase-dot:nth-child(5):before {
  animation-delay: -0.7s;
}

.sk-chase-dot:nth-child(6):before {
  animation-delay: -0.6s;
}

@keyframes sk-chase {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes sk-chase-dot {
  80%,
  100% {
    transform: rotate(360deg);
  }
}

@keyframes sk-chase-dot-before {
  50% {
    transform: scale(0.4);
  }

  100%,
  0% {
    transform: scale(1);
  }
}
</style>
